import React from 'react';
import styled from 'styled-components';
import { Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Flex } from 'antd';
import { DivMinWidth, FlexPadStyled } from '../App';
import { LogoBC } from '../components/LogoBC';
import { Breadcrumbs } from '../components/Breadcrumbs';
import { fonts } from '../assets/constStyles';
import { GisSubMenu } from '../components/GISSubMenu';

const DivBodyPageStyled = styled.div`
  font-family: ${fonts.font3};

  * {
    font-family: inherit;
  }
`;

export const GISPage: React.FC = () => (
    <>
        <Helmet>
            <title>GIS Program</title>
            <meta
                name="description"
                content="AWMAC - Architectural Woodwork Manufacturers Association of Canada AWARDS"
            />
            <link rel="canonical" href='https://awmacbc.com/gis'/>
        </Helmet>
        <DivMinWidth>
            <div style={{ padding: '20px' }}>
                <FlexPadStyled vertical>
                    <LogoBC/>
                </FlexPadStyled>
                <Flex style={{ margin: '20px 0' }}>
                    <Breadcrumbs/>
                </Flex>
                <h1 style={{ textAlign: 'center', fontFamily: fonts.font2, marginBottom: 20 }}>GUARANTEE YOUR WOODWORK</h1>
                <DivBodyPageStyled>
                    <GisSubMenu />
                    <Outlet />
                </DivBodyPageStyled>
            </div>
        </DivMinWidth>
    </>
);
